module.exports = __webpack_public_path__ + "static/media/wse_icon_hl.edc62507.svg";